import { render, staticRenderFns } from "./user_menu_profile_item.vue.js?vue&type=template&id=2f30f019!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_profile_item.vue?vue&type=template&id=2f30f019"
import script from "./user_menu_profile_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_profile_item.vue?vue&type=script&lang=js"
export * from "./user_menu_profile_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_profile_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f30f019')) {
      api.createRecord('2f30f019', component.options)
    } else {
      api.reload('2f30f019', component.options)
    }
    module.hot.accept("./user_menu_profile_item.vue.js?vue&type=template&id=2f30f019!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_profile_item.vue?vue&type=template&id=2f30f019", function () {
      api.rerender('2f30f019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/user_menu_profile_item.vue"
export default component.exports